<template>
  <div>
    <!-- <vue-friendly-iframe :src="this.urlAddress"></vue-friendly-iframe> -->
    <iframe id="iframe" class="content-iframe" :src="this.urlAddress"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    urlAddress: String,
    msg: String
  },
  data() {
    return {
    }
  },
  mounted() {

  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css" ></style>